import { object, number, array, string } from '@gogame/schemas';
import { defaultRangePreset, rangePresets } from '@gogame/intl-ts';

import {
  FILTER_PERIOD,
  FILTER_TYPES,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_COUNTRIES,
  FILTER_FRAUD_PROTECTIONS,
  FILTER_PROMO_CODES,
  FILTER_ACTIVITY_TYPE,
  FILTER_OWNERS,
} from 'scenes/Campaigns/constants';

export const filtersSchema = object({
  [FILTER_PERIOD]: array(string())
    .required()
    .default(rangePresets.LAST_90_DAYS.value)
    .constants(defaultRangePreset),
  [FILTER_TYPES]: array(number()).default([1]),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_COUNTRIES]: array(number()),
  [FILTER_FRAUD_PROTECTIONS]: array(number()),
  [FILTER_PROMO_CODES]: number(),
  [FILTER_ACTIVITY_TYPE]: array(number()),
  [FILTER_OWNERS]: array(number()),
});

export const EMPTY_FILTERS = {
  [FILTER_PERIOD]: rangePresets.LIFETIME.value,
};
